<script>
export default {
  props: {
    direction: {
      type: String,
      required: true,
    },

    field: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    directionIcon() {
      return this.direction === 'down' ? '-alt' : ''
    },
  },
}
</script>

<template>
  <font-awesome-icon
    :icon="['fas', 'sort-alpha-down' + directionIcon]"
    class="ml-1"
    :class="{
      'text-gray-400': value !== field,
    }"
  />
</template>
